import ClassNames from "classnames";
import * as React from "react";
import IconLoading from "../_assets/icon-loading.svg";
import IconUpload from "../_assets/icon-upload.svg";
import Styles from "./FileUpload.module.css";

import Typography from "../Typography";

interface OnChangeActionArgType {
  file: File;
  reader: FileReader;
}

export interface Props {
  className?: string;
  disabled?: boolean;
  errors?: string[];
  helperText?: string;
  id: string;
  inputRef?: any;
  label: string;
  name?: string;
  loading?: boolean;
  onChangeAction?: (obj: OnChangeActionArgType) => void;
  required?: boolean;
  nativeRequired?: boolean;
  variant?: "solid" | "outlined" | "text";
  withForm?: boolean;
}

const FileUpload: React.FC<Props> = props => {
  const {
    className,
    disabled,
    id,
    errors,
    inputRef,
    helperText,
    label,
    name,
    loading,
    onChangeAction,
    required,
    nativeRequired,
    variant = "solid",
    withForm = true
  } = props;

  const onChange = e => {
    const file: File = e.target.files[0];
    const reader: FileReader = new FileReader();

    reader.onloadend = () => {
      onChangeAction({ file, reader });
    };
    reader.readAsDataURL(file);
  };

  const component = (
    <div className={Styles.wrapper}>
      <label
        className={ClassNames({
          [Styles.button]: true,
          [Styles[variant]]: true,
          [Styles.disabled]: loading || disabled,
          [className]: className
        })}
        htmlFor={id}
      >
        <IconUpload is="svg" />
        <span className={loading ? "block invisible h-0" : ""}>
          {label}{" "}
          {(required || nativeRequired) && <span className={Styles.required} />}
        </span>
        {loading && (
          <div className={Styles.loadingIcon}>
            <IconLoading is="svg" />
          </div>
        )}
      </label>

      {helperText && (
        <Typography body="small" className={Styles.helper}>
          {helperText}
        </Typography>
      )}

      <input
        id={id}
        name={name}
        className="sr-only"
        type="file"
        accept=".pdf,image/*"
        onChange={onChange}
        disabled={disabled}
        required={nativeRequired}
        ref={inputRef}
      />

      {errors &&
        errors.map((error, i) => {
          return (
            <Typography
              body="small"
              className={ClassNames({
                [Styles.error]: true,
                [Styles.firstError]: errors.length !== 1 && i === 0
              })}
              key={`error-${id}-${i}`}
            >
              {error}
            </Typography>
          );
        })}
    </div>
  );

  return withForm ? (
    <form
      className={ClassNames({
        [className]: className
      })}
      encType="multipart/form-data"
    >
      {component}
    </form>
  ) : (
    component
  );
};

export default FileUpload;
